import React from "react";

/** Home page for admins  */
export function Portal() {
    return (
        <div>
            <h1>Admin home page for your organization</h1>
            <p>Please bookmark this page for easier navigation</p>
            <p>Here the master administrator will be able to add additional admins to the system</p>
            <p>
                These additional admins can modify schedules, report scores, and handle nearly
                everything related to competition
            </p>
            <p>
                For more advanced tools such as handling players and teams, the master admin must be
                logged in
            </p>
            <p>
                If at any point you require assistance in handling your Organization, please reach
                contact us
            </p>
        </div>
    );
}
